import $ from 'jquery';
import { NOTIFICATION_EVENTS } from '../../../constants/notifications';
import { ICON } from "../../Icons/Icons";

export const CONFIRM_NOTIFICATION_THEME = {
    DEFAULT: 'default',
    LIGHT: 'light',
    DARK: 'dark',
}

export const CONFIRM_NOTIFICATION_TYPE = {
    DEFAULT: 'default',
    WARNING: 'warning',
    CONFIRM: 'confirm',
}

export const CONFIRM_NOTIFICATION_SIZE = {
    SM: 'sm',
    MD: 'md',
}

export const CONFIRM_BUTTON_SIZE = {
    DEFAULT: 'default',
    FULL: 'full',
}

const DEFAULT_CONFIRM_LOGO = '/textures/bagless_logo.png';
const DEFAULT_MODAL_LOGOS = [
    '/textures/bagless_logo.png',
    '/textures/bagless_logo.svg',
    '/textures/bagless-premium-logo.png',
    '/textures/logo.png',
    '/textures/image.png',
];

const isCustomLogo = (logoSrc = '') => {
    if (!logoSrc || logoSrc.includes('empty.png')) {
        return false;
    }

    return !DEFAULT_MODAL_LOGOS.some((defaultLogo) => logoSrc.includes(defaultLogo));
};

const getCustomLogoFromDom = () => {
    const navLogo = $('.world-top-nav__logo_area__logo img').attr('src');
    const roomLogo = $('.room_logo').attr('src');
    return navLogo || roomLogo || '';
};

class ConfirmNotification {

    constructor({ model = null }) {
        const isTourView = location.pathname === '/worlds/view'
        this.defaults = {
            id: null,
            header: false,
            title: "",
            xBtn: true,
            cancelBtn: true,
            dimmerClose: true,
            message: "",
            success: null,
            onCancel: null,
            error: null,
            position: "top middle",
            withSound: false,
            song: "message",
            logo: true,
            initialValue: "",
            placeholder: "",
            autoFocus: true,
            confirmBtnTxt: "OK",
            cancelBtnTxt: "Cancel",
            disableActions: false,
            disableAutoClose: false,
            successBtn: true,
            payload: null,
            modalTheme: isTourView ? CONFIRM_NOTIFICATION_THEME.DARK : null,
            buttonSize: CONFIRM_BUTTON_SIZE.DEFAULT,
        };

        this.instanceSettings = this.defaults;

        this.model = model;

        this.confirmMode = null;

        this.$elements = {
            confirmModal: $('.notification-confirm-modal'),
        }

        this.eventsListener(this);
    }

    // EVENTS
    eventsListener(self) {
        this.model?.addEventListener(NOTIFICATION_EVENTS.CLOSE, (e) => {
            this.instanceSettings = { ...this.defaults, ...e.data };
            if (this.instanceSettings.closeOnButtonOnly) {
                return;
            }
            this.onClose();
        });

        this.model?.addEventListener(NOTIFICATION_EVENTS.CONFIRM, (e) => {
            this.instanceSettings = { ...this.defaults, ...e.data };
            this.confirmMode = true;
            this.createDialog(this.instanceSettings);
        });
        this.model?.addEventListener(NOTIFICATION_EVENTS.CONFIRM_WITHOUT_CLOSE, (e) => {
            this.instanceSettings = { ...this.defaults, ...e.data, xBtn: false, disableAutoClose: true };
            this.confirmMode = true;
            this.createDialog(this.instanceSettings);
        });

        this.model?.addEventListener(NOTIFICATION_EVENTS.PROMPT, (e) => {
            this.instanceSettings = { ...this.defaults, ...e.data };
            this.confirmMode = false;
            this.createDialog(this.instanceSettings);
        });
        this.model?.addEventListener(NOTIFICATION_EVENTS.PROMPT_WITH_CONFIRM, (e) => {
            this.instanceSettings = { ...this.defaults, ...e.data, enablePrompt: true };
            this.confirmMode = false;
            this.createDialog(this.instanceSettings);
            this.$elements.confirmModal.addClass("prompt-new");

        });

        this.onClose = () => {
            this.$elements.confirmModal.removeClass("visible");
            this.model?.dispatchEvent({ type: NOTIFICATION_EVENTS.CLOSED, data: this.instanceSettings });
            this.reset();
        }

        this.$elements.confirmModal.find(".confirm-close, .confirm-cancel").on("click", (e) => {
            const { onCancel } = this.instanceSettings;
            if (this.$elements.confirmModal.find(e.currentTarget).is('span')) {
                this.onClose(e);
                return;
            }
            this.onClose(e);
            onCancel && onCancel(e);
        });

        this.$elements.confirmModal.on("click", (e) => {
            if (!this.instanceSettings.dimmerClose) return;
            const { onCancel, disableAutoClose } = this.instanceSettings;
            if (disableAutoClose) {
                return;
            }
            if ($(e.target).is("div.confirm-modal")) {
                this.onClose(e);
                return;
            }
            onCancel && onCancel(e);
            this.$elements.confirmModal.removeClass("visible");
            this.reset();
        });


        this.$elements.confirmModal.find(".confirm-dialog").on("click", (e) => {
            e.stopPropagation();
        });

        this.$elements.confirmModal.find(".confirm-ok").on("click", () => {

            const { error, customComponent } = this.instanceSettings;
            const value = this.$elements.confirmModal.find(".prompt-input").val();
            try {
                if (typeof this.instanceSettings.success === 'function') {
                    if (customComponent) {
                        this.instanceSettings.success({ inputValue: value, componentValue: customComponent.getSelected() }, event);
                        this.instanceSettings.success = null;

                    }
                    else {
                        this.instanceSettings.success(value, event);
                        this.instanceSettings.success = null;

                    }
                }
            }
            catch (err) {
                if (typeof this.instanceSettings.success === 'function') {
                    console.error(err);
                } else {
                    console.log(err);
                }
            }

            this.onClose();
        });

        this.$elements.confirmModal.find(".prompt-ok").on("click", (event) => {

            const { error, customComponent } = this.instanceSettings;

            const value = this.$elements.confirmModal.find(".prompt-input").val();

            try {
                if (typeof this.instanceSettings.success === 'function') {
                    if (customComponent) {
                        this.instanceSettings.success({ inputValue: value, customComponent: customComponent.getSelected() }, event);
                        this.instanceSettings.success = null;

                    }
                    else {
                        this.instanceSettings.success(value, event);
                        this.instanceSettings.success = null;

                    }
                }
            }
            catch (err) {
                if (typeof this.instanceSettings.success === 'function') {
                    //error(err);
                    console.error(err);
                } else {
                    console.log(err);
                }
            }

            this.onClose();
        });

    }

    //METHODS
    createDialog = (data) => {
        const {
            header,
            title,
            xBtn,
            cancelBtn,
            message,
            position,
            withSound,
            song,
            logo,
            initialValue,
            placeholder,
            autoFocus,
            confirmBtnTxt,
            cancelBtnTxt,
            enablePrompt,
            customComponent,
            customComponentTitle,
            disableActions,
            successBtn,
            modalTheme,
            modalType,
            modalSize,
            buttonSize,
        } = data;

        //   console.log('createDialog data',data);
        this.$elements.confirmModal = $('.notification-confirm-modal');

        this.$elements.confirmModal.removeClass("top middle bottom prompt");
        this.$elements.confirmModal.find(".confirm-header").text(title);
        this.$elements.confirmModal.find(".confirm-body").empty().append(message);
        this.$elements.confirmModal.find(".prompt-input").val(initialValue);
        this.$elements.confirmModal.find(".prompt-input").attr('placeholder', placeholder);
        this.$elements.confirmModal.find(".confirm-ok").text(confirmBtnTxt);
        this.$elements.confirmModal.find(".confirm-cancel").text(cancelBtnTxt);
        this.$elements.confirmModal.find(".confirm-custom-component").empty().hide();
        this.$elements.confirmModal.find(".confirm-custom-component-title").empty().hide();
        this.$elements.confirmModal.find(".confirm-header-icon").empty().hide();

        const sceneLogo = this.model?.sceneData?.customLogo;
        const customLogo = isCustomLogo(sceneLogo) ? sceneLogo : getCustomLogoFromDom();
        const headerLogoSrc = isCustomLogo(customLogo) ? customLogo : DEFAULT_CONFIRM_LOGO;
        this.$elements.confirmModal.find(".confirm-header-logo").attr("src", headerLogoSrc);

        header ? this.$elements.confirmModal.find(".confirm-header-wrapper").show() : this.$elements.confirmModal.find(".confirm-header-wrapper").hide();
        logo ? this.$elements.confirmModal.find(".confirm-header-logo").show() : this.$elements.confirmModal.find(".confirm-header-logo").hide();
        xBtn ? this.$elements.confirmModal.find(".confirm-close").show() : this.$elements.confirmModal.find(".confirm-close").hide();
        cancelBtn ? this.$elements.confirmModal.find(".confirm-cancel").show() : this.$elements.confirmModal.find(".confirm-cancel").hide();
        successBtn ? this.$elements.confirmModal.find(".confirm-ok").show() : this.$elements.confirmModal.find(".confirm-ok").hide();

        withSound && this.model.playAudioNotification(song);

        if (disableActions) {
            this.$elements.confirmModal.find(".confirm-ok").hide();
            this.$elements.confirmModal.find(".confirm-cancel").hide();
        }

        const $confirmModal = this.$elements.confirmModal;
        $confirmModal.addClass(this.confirmMode ? `visible ${position}` : `visible ${position} prompt`);

        const customizeClasses = [
            'confirm-modal--theme-default',
            'confirm-modal--theme-dark',
            'confirm-modal--type-default',
            'confirm-modal--type-warning',
            'confirm-modal--type-confirm',
            'confirm-modal--size-sm',
            'confirm-modal--size-md',
            'confirm-modal--button-size-default',
            'confirm-modal--button-size-full',
        ]
        customizeClasses.forEach(cls => {
            $confirmModal.removeClass(cls)
        })

        if (modalTheme && Object.values(CONFIRM_NOTIFICATION_THEME).includes(modalTheme)) {
            this.$elements.confirmModal.addClass(`confirm-modal--theme-${modalTheme}`);
        }
        if (modalType && Object.values(CONFIRM_NOTIFICATION_TYPE).includes(modalType)) {
            this.$elements.confirmModal.addClass(`confirm-modal--type-${modalType}`);

            switch (modalType) {
                case CONFIRM_NOTIFICATION_TYPE.WARNING:
                    this.$elements.confirmModal.find('.confirm-header-icon').html(ICON.WARNING).show()
                    break;
            }
        }
        if (modalSize && Object.values(CONFIRM_NOTIFICATION_SIZE).includes(modalSize)) {
            this.$elements.confirmModal.addClass(`confirm-modal--size-${modalSize}`);
        }
        if (buttonSize && Object.values(CONFIRM_BUTTON_SIZE).includes(buttonSize)) {
            this.$elements.confirmModal.addClass(`confirm-modal--button-size-${buttonSize}`);
        }
        !this.confirmMode && autoFocus && this.$elements.confirmModal.find("#prompt-input").trigger('focus');
        !this.confirmMode && autoFocus && this.$elements.confirmModal.find("#prompt-input").trigger('select');
        enablePrompt && this.$elements.confirmModal.addClass(`visible ${position}`);
        this.$elements.confirmModal.find(".prompt-input-wrapper").hide();
        if (enablePrompt)
            this.$elements.confirmModal.find(".prompt-input-wrapper").show();

        customComponent && this.$elements.confirmModal.find(".confirm-custom-component").append(customComponent.rendered).show();

        if (customComponentTitle) {
            this.$elements.confirmModal.find(".confirm-custom-component-title").show();
            this.$elements.confirmModal.find(".confirm-custom-component-title").html(customComponentTitle);
        }

        this.model?.dispatchEvent({ type: NOTIFICATION_EVENTS.OPENED, data });
    }

    showConfirmNotification = (configs) => {
      this.confirmMode = true;
      this.instanceSettings = {
        ...this.defaults,
        ...configs,
        modalTheme: CONFIRM_NOTIFICATION_THEME.LIGHT,
      }

      this.createDialog(this.instanceSettings)
    }


  reset = () => {
        this.instanceSettings = this.defaults;
        this.$elements.confirmModal.find('.confirm-footer').removeClass('leaveEditMode');
    }
}

export default ConfirmNotification;
